<!-- Select Input for Inspector -->
<script lang="ts">
  let {
    value = $bindable(''),
    options = [],
    onChange,
  }: {
    value: string | number;
    options: Array<{ value: any; label: string }>;
    onChange?: (value: any) => void;
  } = $props();

  function handleChange(event: Event) {
    const target = event.target as HTMLSelectElement;
    const newValue = target.value;
    value = newValue;
    onChange?.(newValue);
  }
</script>

<select
  {value}
  onchange={handleChange}
  class="w-full bg-gray-700 border border-gray-600 rounded px-3 py-2 text-xs text-white focus:outline-none focus:border-neon-primary transition-colors"
>
  {#each options as option}
    <option value={option.value}>{option.label}</option>
  {/each}
</select>
